import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const DraftLink = styled.a`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}

    display: flex;
    height: 28px;
    min-width: 96px;
    padding: 0 8px;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.Text.primary};
    color: ${({ theme }) =>
        theme.Text.primary} !important; // TODO: make it so this isn't necessary - BaseStyle is overwriting this
    border-radius: 4px;
`;
